import React from 'react';
import { Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { FiExternalLink } from 'react-icons/fi';

const HEIDI_LINKS = [
  { href: 'https://www.heidihealth.com/en-gb', label: 'Heidi Website' },
  {
    href: 'https://www.heidihealth.com/en-gb/legal/heidi-scribe-terms-of-use',
    label: 'Heidi Scribe Terms of Use'
  },
  { href: 'https://pard.mhra.gov.uk/manufacturer-details/124122', label: 'MHRA Registration' }
];

const HeidiAiTooltip = () => {
  const { t } = useTranslation('common');

  return (
    <Tooltip
      title={
        <div style={{ fontSize: 11, lineHeight: 1.5, maxWidth: 280 }}>
          <p style={{ margin: '0 0 6px 0', fontWeight: 600 }}>{t('How Heidi AI works')}</p>
          <p style={{ margin: '0 0 6px 0' }}>
            {t(
              'Heidi AI uses advanced natural language processing to automatically generate clinical documentation from your consultation. The AI listens to your conversation and creates structured notes, saving you valuable time.'
            )}
          </p>
          <p style={{ margin: '0 0 6px 0' }}>
            <span style={{ fontWeight: 600 }}>{t('MHRA Regulation:')}</span>{' '}
            {t(
              'Heidi is registered as a Class I Medical Device with the MHRA (Medicines and Healthcare products Regulatory Agency), ensuring it meets rigorous safety and performance standards for use in UK healthcare settings.'
            )}
          </p>
          <p style={{ margin: '0 0 8px 0', fontStyle: 'italic', color: '#93c5fd' }}>
            {t('Always review AI-generated content for accuracy and clinical appropriateness before finalising.')}
          </p>
          <hr style={{ border: 'none', borderTop: '1px solid rgba(255,255,255,0.2)', margin: '4px 0 8px 0' }} />
          <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
            {HEIDI_LINKS.map(({ href, label }) => (
              <a
                key={href}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                className="heidi-tooltip-link"
                style={{ color: '#7bb3f5', fontStyle: 'italic', display: 'inline-flex', alignItems: 'center', gap: 4 }}
              >
                {label} <FiExternalLink size={10} />
              </a>
            ))}
          </div>
        </div>
      }
      placement="right"
      trigger={['hover', 'focus']}
    >
      <InfoCircleOutlined
        aria-label={t('How Heidi AI works')}
        style={{ color: '#6b7280', fontSize: 16, cursor: 'pointer' }}
      />
    </Tooltip>
  );
};

export default HeidiAiTooltip;
